import {
  doTabNamesMatch,
  getBackendTabId,
  normalizeBackendTabs,
} from "../utils/access";

export const NAV_SECTION_LABELS = {
  admin: "Admin",
  leads: "Lead Management System",
  analytics: "Analytics",
  content: "Content Management System",
};

const TAB_ROUTE_CONFIG = [
  { tabName: "Subscriptions", route: "/Subscriptions", section: "admin" },
  { tabName: "Experiment Key", route: "/expkey", section: "admin" },
  { tabName: "Report", route: "/report", section: "admin" },
  { tabName: "Employee", route: "/employee", section: "admin" },
  { tabName: "Roles", tabAliases: ["Role", "Role Management", "Roles Management", "Manage Roles"], route: "/roles", section: "admin" },
  { tabName: "Rewards", route: "/rewards", section: "admin" },
  { tabName: "User Rewards", route: "/user-rewards", section: "admin", adminOnly: true },
  { tabName: "Offers", route: "/offers", section: "admin" },
  { tabName: "Doubt Chat", route: "/doubt-chat", section: "admin" },
  { tabName: "Inquiries", tabAliases: ["Enquiries"], route: "/inquiries", section: "leads" },
  { tabName: "Business Enquiries", route: "/business-enquiries", section: "leads" },
  { tabName: "Bulk Login", route: "/bulk-login", section: "leads" },
  { tabName: "User Cart", route: "/user-cart", section: "leads" },
  { tabName: "Qr Code Leads", route: "/qr-code", section: "leads" },
  { tabName: "Summer Camp Referrals", route: "/summer-referrals", section: "leads" },
  { tabName: "Register", route: "/register", section: "leads" },
  { tabName: "Institute", route: "/institute", section: "leads" },
  { tabName: "Finance", route: "/finance-tab", section: "leads" },
  { tabName: "User Experiment Report", route: "/user-exp-report", section: "leads" },
  { tabName: "Plan Selected", route: "/plan-selected", section: "leads" },
  { tabName: "Login Analytics", route: "/analytics/login-analytics", section: "analytics", adminOnly: true },
  { tabName: "Skills", route: "/skills", section: "content" },
  { tabName: "Labs", route: "/labs", section: "content" },
  { tabName: "Specialization", tabAliases: ["Specialisation", "Manage Specialisation", "Manage Specialization"], route: "/specialization", section: "content" },
  { tabName: "Blogs", route: "/blogs", section: "content" },
  { tabName: "Labs SEO", route: "/labs-seo", section: "content" },
  { tabName: "Learn", tabAliases: ["Learn SEO"], route: "/learn", section: "content" },
  { tabName: "Success Stories", route: "/testimonials", section: "content" },
  { tabName: "Generate Questions", route: "/generate-questions", section: "content" },
  { tabName: "Review Questions", route: "/review-questions", section: "content" },
];

const warnedUnmappedTabIds = new Set();

export const getRouteConfigByTabName = (tabName) =>
  TAB_ROUTE_CONFIG.find((config) =>
    [config.tabName, ...(config.tabAliases || [])].some((name) =>
      doTabNamesMatch(name, tabName)
    )
  );

export const buildNavLinksFromBackendTabs = (backendTabs) => {
  const tabs = normalizeBackendTabs(backendTabs);
  const sections = Object.entries(NAV_SECTION_LABELS).map(([sectionKey, label]) => ({
    tag: label,
    sectionKey,
    tabs: [],
  }));
  const sectionMap = new Map(sections.map((section) => [section.sectionKey, section]));
  tabs.forEach((backendTab) => {
    const config = getRouteConfigByTabName(backendTab.tab_name);

    if (!config?.route || !config?.section) {
      const warningKey = String(backendTab.tab_id);
      if (!warnedUnmappedTabIds.has(warningKey)) {
        warnedUnmappedTabIds.add(warningKey);
        console.warn(
          "[Admin UI navigation] Backend tab has no sidebar/dashboard route mapping and will not render:",
          {
            tab_id: backendTab.tab_id,
            tab_name: backendTab.tab_name,
          }
        );
      }
      return;
    }

    sectionMap.get(config.section)?.tabs.push({
      id: getBackendTabId(backendTab),
      title: backendTab.tab_name,
      route: config.route,
      adminOnly: config.adminOnly,
    });
  });

  return sections;
};

export default buildNavLinksFromBackendTabs;
